import React from "react";
import { Strings } from "INTL/i18n";
import "./Payer.less";

class PaymentBase extends React.Component {
  componentDidMount() {}
  /**
   * This the common header to render fro payment page
   */
  renderHeader(language) {
    return (
      <div>
        <header className={"App_header"}>
          <div className={language === "ar"?"logoAr":"logo"}></div>
        </header>
        <div className={"Rectangle_bar"}></div>
      </div>
    );
  }
  /**
   * This is the common error msg ui used across payment page
   * @param {String} errorMessage
   */
  renderErrorPage(errorMessage) {
    return (
      <div>
        <div className="Payer_error"></div>
        <div className="Payer_error_header_text">{Strings("oops")}</div>
        <div className="Payer_error_desc_text">{errorMessage}</div>
      </div>
    );
  }
  render() {
    return <div></div>;
  }
}

export default PaymentBase;



// WEBPACK FOOTER //
// ./src/modules/Payer/PaymentBase.js